<div class="flex-column">
    <router-outlet></router-outlet>
</div>
